import React from 'react';
import { AutocompleteInput } from 'react-admin';

const choices = [
    { id: 'generic', name: 'Generic' },
    { id: 'maintenance', name: 'Maintenance' },
    { id: 'production', name: 'Production' }
];

const BudgetMethodInput = ({ classes, record, source = "budget_type", ...props }) => {
    if (record && record[source] && !choices.find((item) => item.id === record[source])) {
        choices.push({ id: record[source], name: record[source] });
    }

    return (
        <AutocompleteInput choices={choices} source={source} record={record} allowEmpty {...props} />
    );
};

export default BudgetMethodInput;
